import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const uploadAsset = async (animationId, file, meta = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  if (meta.name) formData.append("name", meta.name);
  if (meta.duration) formData.append("duration", String(meta.duration));
  if (meta.width) formData.append("width", String(meta.width));
  if (meta.height) formData.append("height", String(meta.height));

  const response = await request(
    getEndpoint("studio", "uploadAsset", animationId),
    { body: formData },
  );
  return response.data;
};

export const fetchAssets = async (animationId) => {
  const response = await request(
    getEndpoint("studio", "getAssets", animationId),
  );
  return response.data;
};

export const deleteAsset = async (animationId, assetId) => {
  await request(getEndpoint("studio", "deleteAsset", animationId, assetId));
};

export const renameAsset = async (animationId, assetId, name) => {
  const response = await request(
    getEndpoint("studio", "renameAsset", animationId, assetId),
    { body: { name } },
  );
  return response.data;
};

export const trimAsset = async (animationId, assetId, payload) => {
  const result = await request(
    getEndpoint("studio", "trimAsset", animationId, assetId),
    { body: payload },
  );
  return result.data; // returns updated or new asset
};